import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { url: String, redirectUrl: String }
  static targets = [ 'flashContainer' ]

  connect() {
    this.pollState()
  }

  disconnect() {
    this.resetTimer()
  }

  resetTimer() {
    clearTimeout(this.timer)
  }

  redirect() {
    window.location.href = this.redirectUrlValue || window.location.href
  }

  pollState() {
    fetch(this.urlValue, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if(response.status == 404) { // job might be finished and deleted already
        this.redirect()
        return
      } else if (!response.ok) {
        throw new Error('Response not ok.')
      } else {
        return response.json()
      }
    })
    .then(data => {
      if(!data) {
        // lands here after 404
        return
      }

      // Redirect on success
      if (data.attributes.state == 'completed') {
        this.flashContainerTarget.innerHTML = `<div class="alert alert-info">Processing finished.</div>`
        this.redirect()
        return true
      }

      // Bomb out on error
      if (data.attributes.state == 'error') {
        this.flashContainerTarget.innerHTML = `<div class="alert alert-danger">Processing error.</div>`
        return true
      }

      // set state of job
      this.flashContainerTarget.dataset.state = data.attributes.state

      this.flashContainerTarget.innerHTML = `<div class="alert alert-warning">Processing ${data.attributes.state}.</div>`

      this.timer = setTimeout(this.pollState.bind(this), 5000)
    })
  }
}
